module.exports = __webpack_public_path__ + "static/media/palm-bnb.133df57d.png";